import { getAxios } from '../axios';
import {
  addParam,
  errorCatch,
  getNotificationId,
  getTokenHeaders
} from '../helper';
import {
  ENDPOINT_ARCHIVE_SERVICE_SETTINGS,
} from '../../config/endpoints';
import { Messages } from '../../config';
import { store } from '../../store/store';
import { displayNotification } from '../../store/actions/notification';
import { NOTIFICATION_SUCCESS } from '../../store/actions/types';

/**
 * Update archive service setting
 * @param {object} payload
 * @param {string} payload.archiveServiceSettingId
 * @param {object} payload.data
 * @param {number} payload.data.status
 * @param {string} [payload.notificationId]
 * @returns {Promise<T>}
 */
export function updateArchiveServiceSetting(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_ARCHIVE_SERVICE_SETTINGS,
      {
        '{archiveServiceSetting}': payload.archiveServiceSettingId,
      }
    ),
    payload.data,
    getTokenHeaders()
  )
    .then(response => {
      if (response && response.data) {
        store.dispatch(
          displayNotification(
            NOTIFICATION_SUCCESS,
            Messages.UPDATE_RESOURCE_SUCCESS,
            payload.notificationId
          )
        );

        return response.data;
      }

      return null;
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId(payload));

        return e.response;
      }
    );
}

